import React from "react";

// mui icons
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CircleIcon from "@mui/icons-material/Circle";

// mui components
import { Stack, Divider, Box } from "@mui/material";

// custom components
import Heading6 from "../typography/heading-06";
import Body2 from "../typography/body-02";

// custom styles
import styles from "./index.module.scss";

const LoanProgress = ({
	loanSteps,
	currentStep,
	clickNavigation,
	setLoanApplicationStage,
	onNavigateToStage,
	incompleteSections = new Set(),
	completedSections = new Set(),
	loanCreated = true,
}) => {
	const handleStepClick = (index) => {
		if (!clickNavigation || currentStep === index) {
			return;
		}

		if (onNavigateToStage) {
			onNavigateToStage(index);
			return;
		}

		setLoanApplicationStage?.(index);
	};

	const isStepComplete = (index) => {
		if (!loanCreated) {
			return false;
		}

		return completedSections.has(index);
	};

	const isStepEnabled = (index) => {
		if (!loanCreated) {
			return index === currentStep;
		}

		return completedSections.has(index) || currentStep >= index;
	};

	return (
		<Stack direction="column" className={styles.loanProgressContainer}>
			<Heading6
				text="Application Progress"
				fontType="semibold"
				extraClass={styles.progressTitle}
			/>

			<Stack direction="column" className={styles.loanStepContainer}>
				{loanSteps?.map((item, index) => (
					<Box key={index}>
						<Stack direction="row" className={styles.loanStepDiv}>
							{isStepComplete(index) ? (
								<CircleIcon className={styles.enabledLoanStepDot} />
							) : (
								<CircleOutlinedIcon
									className={
										isStepEnabled(index)
											? styles.enabledLoanStepDot
											: styles.loanStepDot
									}
								/>
							)}

							<Body2
								text={item}
								extraClass={`${
									isStepEnabled(index)
										? styles.enabledLoanStepText
										: styles.loanStepText
								} ${incompleteSections.has(index) ? styles.incompleteLoanStepText : ""}`}
								isLink={clickNavigation && currentStep !== index}
								handleClick={() => handleStepClick(index)}
							/>
						</Stack>
						<Box className={styles.dividerContainer}>
							{index + 1 !== loanSteps?.length && (
								<Divider
									orientation="vertical"
									className={
										isStepComplete(index)
											? styles.enabledLoanStepDivider
											: styles.loanStepDivider
									}
								/>
							)}
						</Box>
					</Box>
				))}
			</Stack>
		</Stack>
	);
};

export default LoanProgress;
